import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de Rounding - Arrondissez les nombres avec précision";
const DESCRIPTION =
  "Calculatrice de Rounding - Arrondissez les nombres avec précision pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de rounding arrondissez les nombres avec précision, calculatrice de rounding arrondissez les nombres avec précision, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/rounding-calculator";
function RoundingCalculator() {
  const [number, setNumber] = useState("");
  const [decimals, setDecimals] = useState("2");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      if (!number) {
        setError("Veuillez entrer un nombre");
        setResult("");
        return;
      }
      const num = parseFloat(number);
      const decimalPlaces = parseInt(decimals);
      if (isNaN(num) || isNaN(decimalPlaces)) {
        setError("Veuillez entrer des valeurs valides");
        setResult("");
        return;
      }
      const rounded = num.toFixed(decimalPlaces);
      setResult(rounded);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Arrondissez les nombres à n'importe quel nombre de décimales avec cette calculatrice simple et efficace.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label htmlFor="number">Nombre:</label>
                    <input
                      type="number"
                      id="number"
                      placeholder="Entrez le nombre"
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                      className="form-control"
                      step="any"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="decimals">Décimales:</label>
                    <input
                      type="number"
                      id="decimals"
                      placeholder="Nombre de décimales"
                      value={decimals}
                      onChange={(e) => setDecimals(e.target.value)}
                      className="form-control"
                      min="0"
                    />
                  </div>
                  <button
                    className="btn btn-success"
                    onClick={handleCalculate}
                  >
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Résultat: {result}
                  </p>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>L'arrondi</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        L'arrondi est une opération qui consiste à ajuster un nombre
                        à une valeur plus simple ou plus proche pour faciliter les calculs
                        ou présenter des estimations. Il peut s'effectuer à l'entier le plus
                        proche ou à une valeur décimale spécifique.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Dixièmes (1)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au dixième signifie conserver un chiffre après la virgule.
                        Exemple : 2,76 arrondi au dixième = 2,8 ; 2,74 = 2,7.
                        Utile pour les mesures nécessitant une précision raisonnable.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Centièmes (2)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au centième signifie conserver deux chiffres après la virgule.
                        Exemple : 2,765 arrondi au centième = 2,77 ; 2,764 = 2,76.
                        Utilisé en comptabilité et en ingénierie.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Millièmes (3)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au millième signifie conserver trois chiffres après la virgule.
                        Exemple : 2,7654 arrondi = 2,765 ; 2,7656 = 2,766.
                        Utilisé en sciences et en médecine.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Dix-millièmes (4)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au dix-millième signifie conserver quatre chiffres après la virgule.
                        Exemple : 2,76543 arrondi = 2,7654 ; 2,76545 = 2,7655.
                        Nécessaire en physique théorique et en analyse financière précise.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Cent-millièmes (5)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au cent-millième signifie conserver cinq chiffres après la virgule.
                        Exemple : 2,765432 arrondi = 2,76543 ; 2,765435 = 2,76544.
                        Utilisé dans les applications scientifiques et d'ingénierie avancées.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Millionièmes (6)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au millionième signifie conserver six chiffres après la virgule.
                        Exemple : 2,7654321 arrondi = 2,765432 ; 2,7654326 = 2,765433.
                        Utilisé dans les recherches scientifiques les plus précises.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Dizaines (-1)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir à la dizaine la plus proche.
                        Exemple : 25 arrondi = 30 ; 24 = 20.
                        Commun dans les estimations rapides et les budgets approximatifs.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Centaines (-2)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir à la centaine la plus proche.
                        Exemple : 250 arrondi = 300 ; 240 = 200.
                        Utilisé dans les domaines financiers et économiques.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Milliers (-3)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au millier le plus proche.
                        Exemple : 2750 arrondi = 3000 ; 2250 = 2000.
                        Courant dans les analyses économiques et les estimations de population.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Millions (-6)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au million le plus proche.
                        Exemple : 2 750 000 arrondi = 3 000 000 ; 2 250 000 = 2 000 000.
                        Utilisé dans les analyses macro-économiques et démographiques.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/2</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au demi le plus proche.
                        Exemple : 2,7 arrondi = 2,5 ; 2,8 = 3.
                        Utile dans la vie quotidienne avec des fractions simples.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/4</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au quart le plus proche.
                        Exemple : 2,6 arrondi = 2,5 ; 2,7 = 2,75.
                        Utile en cuisine et pour les mesures simples.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/8</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au huitième le plus proche.
                        Exemple : 2,625 arrondi = 2,625 ; 2,6375 = 2,625.
                        Utilisé en menuiserie et en ingénierie.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/16</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au seizième le plus proche.
                        Exemple : 2,0625 arrondi = 2,0625 ; 2,06875 = 2,0625.
                        Utilisé dans les travaux de précision comme l'horlogerie.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/32</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au trente-deuxième le plus proche.
                        Exemple : 2,03125 → reste 2,03125 ; 2,034375 = 2,03125.
                        Utilisé dans les travaux de précision et les domaines scientifiques.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/64</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Arrondir au soixante-quatrième le plus proche.
                        Exemple : 2,015625 arrondi = 2,015625 ; 2,0234375 = 2,015625.
                        Utilisé en physique théorique et dans les recherches de haute précision.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default RoundingCalculator;
